import React, { Component } from 'react';
import Main from './components/main/component';
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){
        //this.initializeReactGA();
        //this.initializeReactGA4();
    }

    initializeReactGA() {
        //ReactGA.initialize("UA-133715853-2");
    }

    initializeReactGA4() {
        //ReactGA4.initialize('G-7EZ6NSPJLP');
    }

    render() {
        return (
            <Main />
        )
    }

}

export default App



// WEBPACK FOOTER //
// ./src/App.js